export type Asset = string;

export type Manifest = {
	assets: {
		[id: string]: Asset[];
	};
	publicPath: string;
};

export const getAssetUrlsFromId = (manifest: Manifest, id: string): Asset[] | undefined => {
	if (!manifest.assets || !manifest.assets[id]) {
		return;
	}

	return manifest.assets[id].map((asset) => `${manifest.publicPath}${asset}`);
};
